import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Breadcrumb from '@/components/base/Breadcrumb';
import { usePageMeta } from '@/hooks/usePageMeta';
import { plotEpisodes } from '@/mocks/plotEpisodes';
import { castMembers } from '@/mocks/castMembers';
import { newsArticles } from '@/mocks/newsArticles';

const blocks = [
  {
    title: '我们做什么',
    paragraphs: [
      '本站是一个围绕电视剧《禁止的爱善良的小姨子》建立的非官方资料专题，整理分集剧情、演员资料与幕后动态，帮助观众在追剧之后回看细节、理解人物关系。',
      '我们不做剧集评价的裁判，也不提供未经确认的消息。所有内容以「可回看、可对照」为标准整理：每一集有独立的剧情档案，每一位演员有独立的资料页，每一条动态注明发布时间与来源类型。',
    ],
  },
  {
    title: '内容范围',
    paragraphs: [
      '剧情部分覆盖全十二集，包含分集名称、剧情梗概、播出日期与单集时长；演员部分收录八位主创，说明演员本人资料与剧中角色的处境；动态部分归档收视消息、主创访谈、幕后制作与专题策划。',
      '本站不提供视频播放、下载或任何形式的资源分发。所有涉及播放的功能模块仅做前端结构演示，不存在真实的播放成功状态。',
    ],
  },
  {
    title: '内容说明',
    paragraphs: [
      '站内剧照、人物照片与剧情文本均为专题演示素材，用于展示页面结构与阅读体验，不代表剧集官方发布的物料。',
      '部分幕后信息、访谈内容为编辑整理的演示文本，如需引用请以官方渠道为准。若内容涉及权益问题，可通过下方联系方式与我们沟通。',
    ],
  },
];

export default function About() {
  usePageMeta({
    title: '关于本站 - 禁止的爱善良的小姨子影视专题',
    description:
      '了解禁止的爱善良的小姨子专题站的定位、内容范围与编辑原则，查看版权申明、联系方式与使用条款。',
    keywords: '关于本站,禁止的爱善良的小姨子专题,版权申明,使用条款',
  });

  return (
    <SiteLayout>
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full px-4 py-5 md:px-8">
          <Breadcrumb items={[{ label: '关于本站' }]} />
        </div>
      </div>

      <section className="mx-auto w-full max-w-[1120px] px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-8">
            <p className="text-xs tracking-[0.24em] text-primary-600">ABOUT THIS SITE</p>
            <h1 className="mt-3 font-heading text-3xl leading-snug text-foreground-950 md:text-4xl">
              关于「禁止的爱善良的小姨子」专题站
            </h1>
            <p className="mt-5 max-w-2xl border-l-2 border-accent-500 pl-4 text-[15px] leading-[1.95] text-foreground-700">
              一个家的故事，值得被慢慢读完。我们把十二集剧情、八位主创和三年的周边消息整理成可以随时翻看的档案，
              让每一次回看都能对上细节。
            </p>

            <div className="mt-9 space-y-9">
              {blocks.map((block) => (
                <section key={block.title}>
                  <h2 className="flex items-center gap-2 font-heading text-xl text-foreground-900">
                    <span className="h-5 w-[3px] rounded-full bg-primary-600" />
                    {block.title}
                  </h2>
                  <div className="mt-3 space-y-3 text-[15px] leading-[1.95] text-foreground-700">
                    {block.paragraphs.map((paragraph) => (
                      <p key={paragraph.slice(0, 12)}>{paragraph}</p>
                    ))}
                  </div>
                </section>
              ))}

              <section className="rounded-lg border border-background-200 bg-background-100/60 p-6">
                <h2 className="flex items-center gap-2 font-heading text-xl text-foreground-900">
                  <span className="h-5 w-[3px] rounded-full bg-primary-600" />
                  版权申明
                </h2>
                <div className="mt-3 space-y-3 text-sm leading-[1.9] text-foreground-600">
                  <p>
                    本站为非商业性质的剧集资料整理站点，站内原创的剧情概述、专题策划与页面设计归本站所有，
                    未经许可不得整站转载或用于商业用途。
                  </p>
                  <p>
                    剧名、角色名称及相关标识归原权利方所有。站内配图均为演示素材，仅用于页面展示，
                    不代表官方发布物料。如权利方认为内容使用不当，请通过下方邮箱联系，我们会尽快处理。
                  </p>
                </div>
              </section>

              <section>
                <h2 className="flex items-center gap-2 font-heading text-xl text-foreground-900">
                  <span className="h-5 w-[3px] rounded-full bg-primary-600" />
                  联系方式
                </h2>
                <div className="mt-3 space-y-2 text-sm leading-relaxed text-foreground-600">
                  <p>
                    编辑信箱：
                    <span className="text-primary-600">editor@forbidden-love.example</span>
                  </p>
                  <p>内容纠错与合作沟通，请在邮件标题注明「专题站」字样，我们通常会在三个工作日内回复。</p>
                  <p className="text-xs text-foreground-400">本站为演示站点，邮箱地址仅用于展示联系方式结构。</p>
                </div>
              </section>

              <section>
                <h2 className="flex items-center gap-2 font-heading text-xl text-foreground-900">
                  <span className="h-5 w-[3px] rounded-full bg-primary-600" />
                  使用条款
                </h2>
                <ul className="mt-3 space-y-2.5 text-sm leading-[1.9] text-foreground-600">
                  {[
                    '本站内容仅供个人观剧参考与交流，不得用于任何商业用途。',
                    '站内不提供视频播放、下载或资源跳转服务，请通过正版渠道观看剧集。',
                    '引用站内剧情概述或专题内容时，请注明来源并保留原文链接。',
                    '站内搜索、筛选、分页与分享均为前端演示功能，不构成任何服务承诺。',
                  ].map((item) => (
                    <li key={item} className="flex gap-2">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </section>
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="sticky top-[92px] space-y-4">
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <p className="text-xs tracking-[0.2em] text-foreground-400">内容概览</p>
                <div className="mt-4 grid grid-cols-3 gap-2 text-center">
                  {[
                    { value: plotEpisodes.length, label: '分集剧情' },
                    { value: castMembers.length, label: '演员资料' },
                    { value: newsArticles.length, label: '动态文章' },
                  ].map((item) => (
                    <div key={item.label} className="rounded-md bg-background-100 py-3">
                      <p className="font-heading text-xl text-primary-600">{item.value}</p>
                      <p className="mt-1 text-[11px] text-foreground-500">{item.label}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="rounded-lg border border-background-200 bg-background-100/70 p-5">
                <p className="text-xs tracking-[0.2em] text-foreground-400">快速浏览</p>
                <ul className="mt-3 divide-y divide-background-200">
                  {[
                    { label: '从第一集开始读剧情', path: '/detail/plot/1' },
                    { label: '查看完整演员名单', path: '/category/cast' },
                    { label: '人物关系专题梳理', path: '/detail/news/7' },
                    { label: '幕后制作花絮', path: '/detail/news/3' },
                  ].map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="group flex items-center justify-between gap-3 py-3 text-sm text-foreground-700 transition-colors hover:text-primary-600"
                      >
                        <span>{link.label}</span>
                        <span className="flex h-4 w-4 items-center justify-center text-xs text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-500">
                          <i className="ri-arrow-right-line" />
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-lg bg-primary-950 p-5 text-background-100">
                <p className="font-heading text-base text-background-50">一条提醒</p>
                <p className="mt-2 text-xs leading-relaxed text-background-100/70">
                  本文档仅整理剧情与周边资料，不提供任何观看或下载入口。支持正版，是对创作者最直接的尊重。
                </p>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </SiteLayout>
  );
}